import { useParams } from "react-router-dom";

export const useLang = () => {
  const { lang } = useParams();
  return lang === "en" ? "en" : "fr";
};

export const lpath = (lang, p = "") => `/${lang}${p}`;
